import { io } from 'socket.io-client';
import { Capacitor } from '@capacitor/core';

const getSocketUrl = () => {
  if (import.meta.env.VITE_SOCKET_URL) {
    return import.meta.env.VITE_SOCKET_URL;
  }
  // In native Android production, window.location.origin is https://localhost,
  // so we need to explicitly use the production server URL instead of falling
  // back to localhost (which doesn't exist in the shipped APK).
  const isNativeProduction = Capacitor.isNativePlatform() && !import.meta.env.DEV;
  if (isNativeProduction) {
    return 'https://psyde-chat.pages.dev';
  }
  return window.location.hostname === 'localhost' ? 'http://localhost:3000' : window.location.origin;
};

export const socketUrl = getSocketUrl();
export const socket = io(socketUrl, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export default socket;
